<template>
  <section class="my-3">
    <FinalTaxesResultHeader
      :title="$t('tax.final-taxes-result')"
      :description="$t('tax.final-taxes-result-desc')"
    />
    <div class="is-flex is-flex-centered my-5 pb-5">
      <ButtonView
        icon-left="cls-download-bottom"
        class="is-one-fifth has-text-primary has-border-primary"
        :disabled="!hasCalculated"
        @click="download"
        :data-e2e="TaxCypressAttribute.finalTaxesCalculator.buttons.DOWNLOAD"
      >
        {{ $t('tax.download-results') }}
      </ButtonView>
    </div>
    <div class="is-flex is-justify-content-space-around my-5">
      <FinalTaxesResultItem :title="$t('tax.estimated-final-taxes')" class="p-r-20">
        <template #value>
          <slot name="final" />
        </template>
      </FinalTaxesResultItem>
      <FinalTaxesResultItem :title="$t('tax.payable-at-spouse-death')" class="p-l-20">
        <template #value>
          <slot name="spouse" />
        </template>
      </FinalTaxesResultItem>
    </div>
  </section>
</template>

<script>
import { TaxCypressAttribute } from '@/modules/tax/constants/TaxCypressAttribute';
import { HasCalculatorMixin } from '@/modules/tax/mixins/HasCalculatorMixin';
import FinalTaxesResultHeader from '@/modules/tax/components/presentational/finaltaxescalculator/FinalTaxesResultHeader.vue';
import FinalTaxesResultItem from '@/modules/tax/components/presentational/finaltaxescalculator/FinalTaxesResultItem.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesResult',
  emits: ['download'],
  slotsDefinition: {
    final: {},
    spouse: {}
  },
  mixins: [HasCalculatorMixin],
  components: { ButtonView, FinalTaxesResultItem, FinalTaxesResultHeader },
  props: {
    hasCalculated: {
      type: Boolean,
      default: false
    }
  },
  static: {
    TaxCypressAttribute
  },
  methods: {
    download() {
      this.$emit('download');
    }
  }
};
</script>

<style scoped>
.is-size-1 {
  font-size: var(--ce-48px) !important;
}
</style>
